import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useBillingStatus } from '../../api/billing';

function money(amount: number): string {
  return amount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
}

const day = (iso: string) =>
  new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });

/**
 * Shown on every page while an invoice is overdue (amber, with the
 * suspension date when automatic suspension is on) or once the workspace is
 * suspended for it (red: reads and paying only). Owners/admins get a link
 * to pay; everyone else is told who can.
 */
export function BillingStatusBanner() {
  const { hasPermission } = useAuth();
  const status = useBillingStatus();
  const { pathname } = useLocation();
  const s = status.data;
  if (!s || (!s.suspended && !s.overdueInvoice)) return null;

  const canPay = hasPermission('billing.manage');
  const inv = s.overdueInvoice;
  const what = inv ? `invoice ${inv.invoiceNumber} (${money(inv.totalAmount)})` : 'an invoice';
  const message = s.suspended
    ? `This workspace is suspended because ${what} is unpaid. You can still view your data; changes, messages and automations are paused until it is paid.`
    : `Invoice ${inv!.invoiceNumber} (${money(inv!.totalAmount)}) was due on ${day(inv!.dueAt)}.${
        inv!.suspendsOn ? ` Pay by ${day(inv!.suspendsOn)} to avoid suspension.` : ''
      }`;

  return (
    <div
      className={`ne-verify-banner${s.suspended ? '' : ' ne-verify-banner--warning'}`}
      role={s.suspended ? 'alert' : 'status'}
    >
      <span>
        {message}
        {canPay ? null : ' Ask an owner or admin to pay it.'}
      </span>
      {canPay && pathname !== '/billing' ? (
        <Link to="/billing" className="ne-verify-banner__action">
          Pay now
        </Link>
      ) : null}
    </div>
  );
}
